module.exports = __webpack_public_path__ + "img/VL_16_03.f1c9c952.png";